import {href, useMatch} from 'react-router';

export const useShouldSkipInitScripts = () => {
  const payWallStandalonePage = Boolean(useMatch(href('/pay-wall-standalone')));
  const cypressEnv = typeof window !== 'undefined' && Boolean(window.Cypress);

  return cypressEnv || payWallStandalonePage;
};
